module.exports = __webpack_public_path__ + "static/media/varie6b.c4ac0f5f.jpg";